module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[],"offset":0},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Mint im Kopf · Professionelle Nachhilfe in Mathe, Physik und Chemie in München und Umgebung","short_name":"Mint im Kopf","start_url":"/","background_color":"#68ba82","theme_color":"#68ba82","display":"minimal-ui","icon":"src/images/mint-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"7a02bc1df65dd42e2088d110d8722280"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
